<template>
  <div class="annual-norm text-dark">
    <div class="d-header">
      <div class="d-header__left">
        <h1>Årsnorm</h1>
        <ChangeSchoolYear :whiteTheme="true"></ChangeSchoolYear>
      </div>
    </div>
    <Loader v-if="isLoading && !isUpdatingTasks"></Loader>
    <template v-else>
      <div class="d-tabs">
        <div class="d-tabs__tab" :class="{'d-tabs__tab--active': !viewIsResult}" @click="viewIsResult = false">
          Tildel opgaver
        </div>
        <div class="d-tabs__tab" :class="{'d-tabs__tab--active': viewIsResult}" @click="viewIsResult = true">
          Se opgørelse
        </div>
      </div>
      <div class="d-tabs__container">
        <template v-if="viewIsResult">
          <AnnualNormResult
            :schoolId="schoolId"
            :users="userWithProps"
            @setIsShowEmploymentEnded="setIsShowEmploymentEnded">
          </AnnualNormResult>
        </template>
        <div class="annual-norm__body" v-else>
          <div class="annual-norm__body__left">
            <AssignHoursNorm
              class="marg-1-bottom"
              :isKindergarten="true"
              @updateUsersHours="readAssignedHours">
            </AssignHoursNorm>
            <ul>
              <li v-for="user in userWithProps"
                  :key="user.user_calendar_id"
                  :class="{'user-item--active': user.v_is_active_user}"
                  class="user-item">
                <div class="user-item__body" @click="setActiveUserId(user.id)">
                  <div class="user-item__name">
                    <img class="user-item__name__img" v-if="user.default_thumb_url" :src="user.default_thumb_url">
                    <p>{{ user.name }}</p>
                  </div>
                  <div class="user-item__right">
                    <div class="user-item__hours">
                      <p><label class="d-label">Arb. tid</label><span>{{ user.v_assigned_total_hours }}</span></p>
                      <p><label class="d-label">Uden børn</label><span>{{ user.v_total_without_kids }}</span></p>
                      <p><label class="d-label">Med børn</label><span>{{ user.v_total_with_kids }}</span></p>
                    </div>
                    <div class="user-item__arrow">
                      <span class="icon-arrow-right4" v-if="!user.v_is_active_user"></span>
                      <span class="icon-arrow-down4" v-else></span>
                    </div>
                  </div>
                </div>
                <div class="user-item__tasks" v-if="user.v_is_active_user">
                  <Loader v-if="!activeNorm" :isSmall="true" bg-color="#fff"></Loader>
                  <table v-else class="d-table d-table__norm d-table__tasks marg-10-bottom">
                    <thead>
                    <tr>
                      <th class="d-table__title" colspan="2"><h4>Norm</h4></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="activeNorm.length < 1">
                      <td>Ingen opgaver uden børn</td>
                    </tr>
                    <tr v-for="item in activeNormFormatted">
                      <td>{{ item.title }}</td>
                      <td>{{ item.value }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <table class="d-table d-table__tasks marg-10-bottom">
                    <thead>
                    <tr>
                      <th class="d-table__title" colspan="2"><h4>Opgaver uden børn</h4></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="user.v_user_tasks_without_kids.length < 1">
                      <td>Ingen opgaver uden børn</td>
                    </tr>
                    <tr v-for="task in user.v_user_tasks_without_kids" :key="task.id">
                      <td>
                        <div class="task-with-edit">
                          <div class="subjects_subject subjects_subject__simple"
                               v-if="task.can_schedule || !task.hasOwnProperty('can_schedule')"
                               :style="[{'border-left-color': task.color}, {'background-color': task.color}]">
                            {{ task.name }}
                          </div>
                          <div v-else class="subjects_subject subjects_subject--not-subject">{{ task.name }}</div>
                        </div>
                      </td>
                      <td class="is-number">
                        {{ task.hours }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table class="d-table d-table__tasks marg-10-bottom">
                    <thead>
                    <tr>
                      <th class="d-table__title" colspan="2"><h4>Opgaver med børn</h4></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="user.v_user_tasks_with_kids.length < 1">
                      <td>Ingen opgaver med børn</td>
                    </tr>
                    <tr v-for="task in user.v_user_tasks_with_kids" :key="task.id">
                      <td>
                        <div class="task-with-edit">
                          <div class="subjects_subject subjects_subject__simple"
                               v-if="task.can_schedule || !task.hasOwnProperty('can_schedule')"
                               :style="[{'border-left-color': task.color}, {'background-color': task.color}]">
                            {{ task.name }}
                          </div>
                          <div v-else class="subjects_subject subjects_subject--not-subject">{{ task.name }}</div>
                        </div>
                      </td>
                      <td class="is-number">
                        {{ task.hours }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </li>
            </ul>
          </div>
          <div class="annual-norm__body__right">
            <div class="annual-norm__body__right__header">
              <div class="flipper-buttons">
                <button @click="isTasksView = true"
                        class="flipper-buttons__button"
                        :class="{'active': isTasksView}">
                  <span class="icon-file-text"></span>
                  Uden børn
                </button>
                <button @click="isTasksView = false"
                        class="flipper-buttons__button"
                        :class="{'active': !isTasksView}">
                  <span class="icon-year-planning"></span>
                  Med børn
                </button>
              </div>
            </div>
            <AnnualNormWithKids v-if="!isTasksView"></AnnualNormWithKids>
            <AnnualNormWithoutKids v-if="isTasksView"></AnnualNormWithoutKids>
          </div>
        </div>
      </div>
    </template>
    <DModal v-if="isShowEmploymentEnded" @close="setIsShowEmploymentEnded(false)" :isBgOverlay="true"
            :show-close="false">
      <div class="do-modal" slot="insertComponent">
        <div class="do-modal__header">
          <h2>Brudt ansættelse</h2>
          <div class="icon__bg-circle ww-modal__header__close" @click="setIsShowEmploymentEnded(false)">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="do-modal__body">
          <AssignHoursEmploymentEnded
            :schoolId="schoolId"
            :users="userWithProps">
          </AssignHoursEmploymentEnded>
        </div>
      </div>
    </DModal>
    <transition name="d-modal">
      <ModalConfirmation
        v-if="isConfirmDeletion"
        :showClose="false"
        @close="$store.commit('setConfirmDeletion', false)"
        @confirm="confirmDelete">
        <h3 slot="item">{{ itemToDelete.name }}</h3>
      </ModalConfirmation>
    </transition>
  </div>
</template>

<script>
import ChangeSchoolYear from '../School/ChangeSchoolYear'
import Loader from '../common/Loader'
import AnnualNormWithoutKids from './AnnualNormWithoutKids'
import AnnualNormWithKids from './AnnualNormWithKids'
import AssignHoursNorm from '../AssignHours/AssignHoursNorm'
import docendo from '../../docendo'
import ModalConfirmation from '../Modals/ModalConfirmation'
import AnnualNormResult from './AnnualNormResult'
import moment from 'moment'
import AssignHoursEmploymentEnded from '../AssignHours/AssignHoursEmploymentEnded.vue'
import DModal from '../common/DModal.vue'

export default {
  components: {
    DModal, AssignHoursEmploymentEnded,
    AnnualNormResult,
    ModalConfirmation, AssignHoursNorm, AnnualNormWithKids, Loader, ChangeSchoolYear, AnnualNormWithoutKids
  },
  data () {
    return {
      isShowEmploymentEnded: false,
      viewIsResult: false,
      isTasksView: true,
      activeUserId: null,
      allVacationsDays: [],
      isUpdatingTasks: false,
      activeNorm: null
    }
  },
  computed: {
    activeNormFormatted () {
      return this.activeNorm.filter(item => !item.title.startsWith('hidden_')).map(item => ({
        ...item,
        value: item.title === 'Periode start' || item.title === 'Periode slut' ? moment(item.value).format('ll') : item.value
      }))
    },
    isConfirmDeletion () {
      return this.$store.state.subjects.isConfirmDeletion
    },
    itemToDelete () {
      return this.$store.state.subjects.itemToDelete
    },
    schoolId () {
      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : window.SCHOOL.id
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    isLoading () {
      return this.$store.state.subjects.isLoading
    },
    tasks () {
      return this.$store.state.subjects.tasks
    },
    filteredTasks () {
      return this.tasks.filter(task => task.subject_type === 'without_kids')
    },
    tasksWithKids () {
      return this.tasks.filter(task => task.subject_type === 'with_kids')
    },
    sortedTasks () {
      return this.filteredTasks.sort((a, b) => a.name.localeCompare(b.name))
    },
    sortedTasksWithKids () {
      return this.tasksWithKids.sort((a, b) => a.name.localeCompare(b.name))
    },
    tasksInHash () {
      return this.filteredTasks.reduce((obj, item) => {
        obj[item.id] = item
        return obj
      }, {})
    },
    tasksWithKidsInHash () {
      return this.tasksWithKids.reduce((obj, item) => {
        obj[item.id] = item
        return obj
      }, {})
    },
    tasksInUserHash () {
      let calIdsWithTasksIds = {}
      this.sortedTasks.forEach(task => {
        if (task.user_calendar_ids) {
          task.user_calendar_ids.forEach(calid => {
            if (calid) {
              if (!calIdsWithTasksIds[calid]) {
                calIdsWithTasksIds[calid] = [task.id]
              } else {
                calIdsWithTasksIds[calid].push(task.id)
              }
            }
          })
        }
      })
      return calIdsWithTasksIds
    },
    tasksWithKidsInUserHash () {
      let calIdsWithTasksIds = {}
      this.sortedTasksWithKids.forEach(task => {
        if (task.user_calendar_ids) {
          task.user_calendar_ids.forEach(calid => {
            if (calid) {
              if (!calIdsWithTasksIds[calid]) {
                calIdsWithTasksIds[calid] = [task.id]
              } else {
                calIdsWithTasksIds[calid].push(task.id)
              }
            }
          })
        }
      })
      return calIdsWithTasksIds
    },
    users () {
      return this.$store.getters.usersSortedOnName
    },
    usersAssignedHoursHash () {
      return this.$store.getters.usersAssignedHoursHash
    },
    userWithProps () {
      return this.users.map(user => {
        const userInHash = this.usersAssignedHoursHash[user.id]
        const isActiveUser = user.id === this.activeUserId
        const userTasksWithoutKidsIds = this.tasksInUserHash[user.user_calendar_id]
        const userTasksWithKidsIds = this.tasksWithKidsInUserHash[user.user_calendar_id]
        let userTotalHoursWithoutKids = 0
        let userTasksWithoutKids = []
        let userTasksWithKids = []
        if (userTasksWithoutKidsIds) {
          userTasksWithoutKids = userTasksWithoutKidsIds.map(id => this.tasksInHash[id])
          userTotalHoursWithoutKids = userTasksWithoutKidsIds.map(hash => this.tasksInHash[hash].hours).reduce((acc, n) => acc + n)
        }
        if (userTasksWithKidsIds) {
          userTasksWithKids = userTasksWithKidsIds.map(id => this.tasksWithKidsInHash[id])
        }
        let assignedTotalHours = 0
        if (userInHash) {
          assignedTotalHours = userInHash.assigned_total_hours
        }
        // Create a new object with the original user properties and the new v_assigned_total_hours property
        return {
          ...user,
          v_assigned_total_hours: parseFloat(assignedTotalHours).toFixed(2),
          v_total_without_kids: parseFloat(userTotalHoursWithoutKids).toFixed(2),
          v_total_with_kids: parseFloat(assignedTotalHours - userTotalHoursWithoutKids).toFixed(2),
          v_is_active_user: isActiveUser,
          v_user_tasks_without_kids: userTasksWithoutKids,
          v_user_tasks_with_kids: userTasksWithKids
        }
      })
    }
  },
  watch: {
    activeSchoolYear () {
      this.readAssignedHours()
      this.readSubjects()
      this.$store.dispatch('readTasks', this.activeSchoolYear.id)
    }
  },
  methods: {
    setIsShowEmploymentEnded (bool) {
      this.isShowEmploymentEnded = bool
    },
    readSubjects () {
      this.$store.dispatch('readSubjects', this.activeSchoolYear.id)
    },
    readTasks () {
      this.$store.dispatch('readTasks', this.activeSchoolYear.id)
    },
    updateTasksFromServer () {
      this.isUpdatingTasks = true
      this.readTasks()
    },
    readAssignedHours () {
      const schoolObj = {
        schoolId: this.schoolId,
        schoolYearId: this.activeSchoolYear.id
      }
      this.$store.dispatch('getUsers', this.schoolId, null)
      this.$store.dispatch('readUsersAssignedHours', schoolObj)
      if (this.activeUserId) {
        this.readUserNorm(this.activeUserId)
      }
    },
    readUserNorm (userId) {
      this.activeNorm = null
      docendo.schoolUserYearRead(this.schoolId, userId, this.activeSchoolYear.name, success => {
        this.activeNorm = success.norm ? success.norm : []
      }, failure => {
        console.log('failed!')
      })
    },
    setActiveUserId (userId) {
      if (this.activeUserId === userId) {
        this.activeUserId = null
      } else {
        this.readUserNorm(userId)
        this.activeUserId = userId
      }
    },
    getSchoolDays () {
      docendo.schoolVacationDaysRead(this.schoolId, success => {
        this.allVacationsDays = success
      }, failure => {
        console.log('failure')
      })
    },
    confirmDelete () {
      if (this.itemToDelete && this.itemToDelete.itemType === 'task') {
        this.$store.dispatch('deleteTask', this.itemToDelete)
        this.$store.commit('setTheDeletedItemId', this.itemToDelete.id)
      }
      this.$store.commit('setConfirmDeletion', false)
      this.$store.commit('setItemToDelete', null)
    },
    setUpdatingFromServer () {
      this.isUpdatingTasks = false
    }
  },
  mounted () {
    this.readAssignedHours()
    this.getSchoolDays()
    window.addEventListener('vueCRUDSubject', () => this.updateTasksFromServer())
    window.addEventListener('vueDoneLoadingTasks', () => this.setUpdatingFromServer())
  },
  beforeDestroy () {
    window.removeEventListener('vueDoneLoadingTasks', () => this.setUpdatingFromServer())
    window.removeEventListener('vueCRUDSubject', () => this.updateTasksFromServer())
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
}

.d-table__tasks {
  border-collapse: collapse;
  background-color: #ffffff;
  width: 100%;
}

.d-table__tasks thead th:first-child,
.d-table__tasks tbody td:first-child {
  max-width: 220px;
  width: calc(100% - 50px);
}

.d-table > thead, .d-table > tfoot {
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
}

.d-table > tfoot tr:last-child {
  font-size: 13px;
}

.d-table > thead > tr > th,
.d-table > tfoot > tr > td {
  padding: 5px;
}

.d-table > thead > tr:first-child, .d-table > tfoot > tr:first-child {
  color: #8898aa;
}

.d-table tr th, .d-table > tfoot tr td {
  padding: 4px 8px;
}

.d-table > tfoot tr td {
  color: #8898aa;
}

.d-table > tfoot tr td.th-sorter--active {
  color: var(--dark-blue);
}

.d-table tbody tr:nth-child(even) {
  background-color: #f9fafb;
}

.d-table tr th h4 {
  color: #3e4450;
}

.d-table tr td {
  padding: 0 8px;
}

.d-table tbody tr:hover {
  background: #eee !important;
}

.subjects_subject {
  width: 265px;
  position: relative;
  padding: 4px 6px;
  height: 30px;
  color: #ffffff !important;
  border-radius: 4px;
  word-break: break-all;
  background: #2c81ba;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
  text-align: left;
  margin: 5px 5px 5px 0px;
  min-width: auto;
  font-weight: bold;
  transition: transform 0.25s;
  animation: fadeIn;
}

.subjects_subject.subjects_subject--not-subject {
  box-shadow: none;
  background-color: transparent;
  color: var(--dark-blue) !important;
  border: 1px solid transparent;
}

.subjects_subject.subjects_subject--not-subject:hover {
  /* border: 1px solid var(--border-color); */
  border: none;
}

.is-number {
  text-align: right;
}

tbody tr:first-child td .subjects_subject {
  margin-top: 5px;
}

tbody tr:last-child td .subjects_subject {
  margin-bottom: 10px;
}

.italic {
  font-style: italic;
}

.annual-norm {
  max-width: 1680px;
  margin: 0 auto;
  padding: 0 1rem;
}

.d-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.d-header__left {
  display: flex;
  align-items: center;
}

.d-header__left > h1 {
  margin-right: 1rem;
}

.flipper-buttons {
  display: flex;
  justify-content: flex-end;
}

.flipper-buttons__button {
  display: flex;
  align-items: center;
  background-color: transparent;
  color: rgba(44, 62, 80, 0.65);
  height: 38px;
  min-width: 130px;
  margin: 0;
  border-radius: 0;
}

.flipper-buttons__button:first-child {
  border-radius: 3px 0 0 3px;
}

.flipper-buttons__button:nth-child(2) {
  border-radius: 0 3px 3px 0;
}

.flipper-buttons__button.active {
  background-color: white;
  color: #2c3e50;
  border: none;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}

.flipper-buttons__button.active > span {
  color: var(--blue);
}

.flipper-buttons__button span {
  margin-right: 10px;
}

.annual-norm__body {
  display: flex;
  gap: 1rem;
}

.annual-norm__body__left {
  max-width: 350px;
  min-width: 350px;
}

.annual-norm__body__right {
  width: 100%;
}

.user-item {
  margin-bottom: 4px;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .07);
  background-color: #ffffff;
  border-radius: 4px;
  padding: 4px 8px;
  transition: transform 0.25s;
}

.user-item:hover:not(.user-item--active) {
  transform: scale(1.02);
}

.user-item__body {
  display: flex;
  justify-content: space-between;
}

.user-item .icon-arrow-down4 {
  font-size: 0.8rem;
  margin-left: 0.5rem;
}

.user-item.user-item--is-open {
  background: #fff !important;
  cursor: default;
}

ul.users-list > li.user-item:hover:not(.user-item__header) {
  background-color: #f6f9fc;
}

.user-item__name {
  display: flex;
  align-items: center;
}

.user-item__name__img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 0 5px;
}

.user-item__name span {
  font-size: 10px;
}

.user-item__hours {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.user-item__arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 8px;
}

.user-item__hours > p {
  display: flex;
  align-items: center;
}

.user-item__hours > p > label {
  margin-bottom: 0;
}

.user-item__hours > p > span {
  font-weight: bold;
  width: 50px;
  text-align: right;
}

.user-item__right {
  display: flex;
}

.user-item__tasks {
  padding-top: 0.5rem;
  margin-top: 0.5rem;
  border-top: 1px solid #eee;
}

.annual-norm__body__right__header {
  margin-bottom: 1rem;
}

.d-tabs {
  display: flex;
  align-items: stretch;
}

.d-tabs__tab {
  border-radius: 4px 4px 0 0;
  padding: 1rem 2rem;
  margin-bottom: -1px;
  margin-right: 0;
  font-weight: 700;
  cursor: pointer;
}

.d-tabs__tab.d-tabs__tab--active {
  background: #edf0f5;
  border: 1px solid #d8d8d8;
  border-width: 1px 1px 0;
  color: #6772e5;
}

.d-tabs__container {
  padding: 1rem;
  border: 1px solid #d8d8d8;
  width: 100%;
  border-radius: 4px;
}

.d-table__norm tr:hover {
  cursor: default;
}

.d-table__norm tr > td:nth-child(2) {
  text-align: right;
}

.d-table__norm tbody tr:last-child {
  font-weight: bold;
  padding: 0.25rem 0;
}

.do-modal__body {
  background: #edf0f5;
  max-height: calc(100vh - 105px);
  overflow-y: auto;
  overscroll-behavior: contain;
  min-width: 500px;
  padding: 1rem;
}

</style>



// WEBPACK FOOTER //
// AnnualNorm.vue?672c0ac1